var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/badges/heart-with-circle.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"i-heart-with-circle\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 25 25\" xml:space=\"preserve\" enable-background=\"new 0 0 25 25\" aria-labelledby=\"icon-heart-with-circle-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productIndex"), env.opts.autoescape);
output += "\">\n    <title id=\"icon-heart-with-circle-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productIndex"), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["heart-image"])), env.opts.autoescape);
output += "\n    </title>\n    <g class=\"i-heart-with-circle__circle-outer\">\n        <path class=\"i-heart-with-circle__circle-path\" d=\"M12.5 25C19.4 25 25 19.4 25 12.5 25 5.6 19.4 0 12.5 0S0 5.6 0 12.5C0 19.4 5.6 25 12.5 25\"/>\n    </g>\n    <path class=\"i-heart-with-circle__heart-path\" d=\"M11.09 17.98c0.38 0.38 0.88 0.56 1.38 0.56 0.5 0.01 1-0.18 1.38-0.56L17.95 13.93c1.4-1.4 1.4-3.66 0-5.06 -1.4-1.4-3.68-1.4-5.09 0l-0.36 0.36 -0.36-0.36c-1.4-1.4-3.68-1.4-5.08 0 -1.41 1.4-1.41 3.66 0 5.06L11.09 17.98z\"/>\n</svg>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/badges/heart-with-circle.j2"] , dependencies)